import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux';
import Axios from "../../../config/Axios";
import Select from 'react-select';
import AsyncPaginate from 'react-select-async-paginate';
import Utils from "../../../Utils";
import ActionSpinner from "../ActionSpinner";
import {smoothlyMenu} from "../../layouts/Helpers";
import AuthUtils from "../../../AuthUtils";
import {
    getAllTenants,
    getTenantContextConfig,
    setUserTimeZone
} from "../../../actions/boCoreActions";
import {setApplicationLocale, updateUserLocale} from "../../../actions/authActions";
import NavigationManager from "./NavigationManager";
import _ from "lodash";
import JoinTenantModal from "../../bo-core/modals/JoinTenantModal/JoinTenantModal";

interface Props extends RouteComponentProps {
    user: any;
    tenant: any;
    uiRoutes: any;
    locale: { label: string, value: string };
    locales: string[];

    setApplicationLocale(locale: { label: string, value: string }): void;
}

interface State {
    currentTimeZone: string;
    pinnedMenu: boolean;
    organizationModal: boolean;
    tenants: any[];
}

class Navigation extends React.Component<Props, State> {
    navigationManager = null;

    constructor(props: Props) {
        super(props);
        this.state = {
            currentTimeZone: Utils.getCookie("Time-Zone"),
            pinnedMenu: true,
            organizationModal: false,
            tenants: []
        }
        this.navigationManager = new NavigationManager();
        this.navigationManager.init(this);
    }

    componentDidMount() {
        $(this.refs.menu).metisMenu();
        document.addEventListener('keydown', this.keydownHandler);
        // Navigation.checkLocation(this.props.history.location);
        if (this.hasUserAccessToParent(this.navigationManager?.configurationGroup)) {
            Navigation.expandMenu("configurations");
            Navigation.expandMenu("rule-engine");
            Navigation.expandMenu("access-control");
            Navigation.expandMenu("status-&-logs");
        }
        Navigation.expandMenu("home");
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (prevState.pinnedMenu !== this.state.pinnedMenu) {
            if (this.state.pinnedMenu) {
                if (this.hasUserAccessToParent(this.navigationManager?.configurationGroup)) {
                    Navigation.expandMenu("configurations");
                    Navigation.expandMenu("rule-engine");
                    Navigation.expandMenu("access-control");
                    Navigation.expandMenu("status-&-logs");
                }
                Navigation.expandMenu("home");
            } else {
                this.checkLocation(this.props.history.location);
            }
        }
        if (_.isEqual([...this.props.uiRoutes].sort(), [...prevProps.uiRoutes].sort()) === false) {
            if (this.hasUserAccessToParent(this.navigationManager?.configurationGroup)) {
                Navigation.expandMenu("configurations");
                Navigation.expandMenu("rule-engine");
                Navigation.expandMenu("access-control");
                Navigation.expandMenu("status-&-logs");
            }
            Navigation.expandMenu("home");
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownHandler);
    }

    keydownHandler = (e) => {
        if (e.ctrlKey && e.altKey && e.keyCode === 77) {
            this.togglePinMenu(e);
        }
    };

    checkLocation = (location) => {
        switch (location.pathname) {
            case `${process.env.ENV_PREFIX}/`:
            case `${process.env.ENV_PREFIX}/globalsearch`:
            case `${process.env.ENV_PREFIX}/managedata`:
                Navigation.expandMenu("home");
                if (this.hasUserAccessToParent(this.navigationManager?.configurationGroup)) {
                    Navigation.shrinkMenu("configurations");
                    Navigation.shrinkMenu("access-control");
                    Navigation.shrinkMenu("status-&-logs");
                }
                break;
            case `${process.env.ENV_PREFIX}/businessobjects`:
            case `${process.env.ENV_PREFIX}/dataviewconfiguration`:
            case `${process.env.ENV_PREFIX}/tagmanagement`:
                if (this.hasUserAccessToParent(this.navigationManager?.configurationGroup)) {
                    Navigation.expandMenu("configurations");
                    Navigation.shrinkMenu("rule-engine");
                    Navigation.shrinkMenu("access-control");
                    Navigation.shrinkMenu("status-&-logs");
                }
                Navigation.shrinkMenu("home");
                break;
            case `${process.env.ENV_PREFIX}/managedata?boc=${Utils.SysRuleEngineRules}`:
            case `${process.env.ENV_PREFIX}/managedata?boc=${Utils.SysRuleEngineActions}`:
                if (this.hasUserAccessToParent(this.navigationManager?.configurationGroup)) {
                    Navigation.expandMenu("configurations");
                    Navigation.expandMenu("rule-engine");
                    Navigation.shrinkMenu("access-control");
                    Navigation.shrinkMenu("status-&-logs");
                }
                Navigation.shrinkMenu("home");
                break;
            case `${process.env.ENV_PREFIX}/users`:
            case `${process.env.ENV_PREFIX}/functionalities`:
            case `${process.env.ENV_PREFIX}/roles`:
            case `${process.env.ENV_PREFIX}/groups`:
                if (this.hasUserAccessToParent(this.navigationManager?.configurationGroup)) {
                    Navigation.expandMenu("configurations");
                    Navigation.shrinkMenu("rule-engine");
                    Navigation.expandMenu("access-control");
                    Navigation.shrinkMenu("status-&-logs");
                }
                Navigation.shrinkMenu("home");
                break;
            case `${process.env.ENV_PREFIX}/audit-log`:
            case `${process.env.ENV_PREFIX}/status`:
                if (this.hasUserAccessToParent(this.navigationManager?.configurationGroup)) {
                    Navigation.expandMenu("configurations");
                    Navigation.shrinkMenu("rule-engine");
                    Navigation.shrinkMenu("access-control");
                    Navigation.expandMenu("status-&-logs");
                }
                Navigation.shrinkMenu("home");
                break;
            default:
                if (location.pathname.includes(`${process.env.ENV_PREFIX}/instance/`)) {
                    Navigation.expandMenu("home");
                    if (this.hasUserAccessToParent(this.navigationManager?.configurationGroup)) {
                        Navigation.shrinkMenu("configurations");
                        Navigation.shrinkMenu("rule-engine");
                        Navigation.shrinkMenu("access-control");
                        Navigation.shrinkMenu("status-&-logs");
                    }
                }
        }
    };

    static expandMenu(menuId) {
        if (document.getElementById(menuId)) {
            document.getElementById(menuId).classList.add('active');
        }
        if (document.getElementById(menuId + '-children')) {
            document.getElementById(menuId + '-children').classList.add('in');
        }
    }

    static shrinkMenu(menuId) {
        if (document.getElementById(menuId)) {
            document.getElementById(menuId).classList.remove('active');
        }
        if (document.getElementById(menuId + '-children')) {
            document.getElementById(menuId + '-children').classList.remove('in');
        }
    }

    activeRoute(routeName) {
        const {pathname, search} = this.props.history.location;
        const fullPath = pathname.concat(search);
        return pathname.indexOf(routeName) > -1 || fullPath.indexOf(routeName) > -1 ||
        decodeURI(fullPath.toLowerCase()).indexOf(routeName.toLowerCase()) > -1 ? "active" : "";
    }

    logout = () => {
        AuthUtils.clearSessionStorageTokens();
        window.location.href = `${process.env.ENV_PREFIX}/login`;
    };

    stopPropagation = (e) => {
        e.stopPropagation();
    };
    static deactivateLeftBorder = (id) => {
        $("#" + id).css("border-left", '#293846')
    };

    onTimeZoneChange = (timezone) => {
        setUserTimeZone(timezone.value)
            .finally(() => {
                Utils.setCookie("Time-Zone", timezone.value, 1000);
                window.location.reload();
            })
    };

    onLocaleChange = (locale) => {
        if (this.props.locale === locale) {
            return;
        }
        updateUserLocale(locale.value)
            .catch(() => {
                toastr.warning("Failed saving user preferred location.")
            });
        this.props.setApplicationLocale(locale);
    };

    loading = async (inputValue: string) => {
        if (AuthUtils.user.mta) {
            try {
                const response = await Axios.instanceV2.get(`tenant/all`);
                const dataArray = []
                    .filter(item => item.label.toLowerCase().includes(inputValue.toLowerCase()))
                    .concat(response.data.map((item: any) => {
                        return {
                            value: item.id,
                            label: item.name
                        }
                    }));

                return {
                    options: dataArray,
                    hasMore: false
                };

            } catch (e) {
                return {
                    options: [],
                    hasMore: false
                }
            }
        } else {
            const tenants = AuthUtils.user.tenants.map(tenant => {
                return {
                    value: tenant.id,
                    label: tenant.name
                }
            })
            return {
                options: tenants,
                hasMore: false
            }
        }
    };

    onTenantChange = (item) => {
        ActionSpinner.get(`user/switch-tenant/${item.value}`, {}, {key: "switchTenant", showOnError: true}, false)
            .then(() => {
                getTenantContextConfig()
                    .then(response => {
                        if (response.data.subdomain === 'n/a') {
                           window.location.reload();
                        } else {
                            const href = window.location.href.split('.') ;
                            console.log(response.data);
                            window.location.replace(`https://${response.data.subdomain}.${href[href.length - 2]}.${href[href.length - 1]}`);
                        }
                    })
            })
            .catch(() => {
                window.location.reload();
            })
    };

    static toggleNavigation(e) {
        e.preventDefault();
        $("body").toggleClass("mini-navbar");
        smoothlyMenu();
        if (!$(document.body).hasClass("mini-navbar")) {
            document.getElementById("hide-nav-btn").classList.add('nav-btn-margin');
        } else {
            document.getElementById("hide-nav-btn").classList.remove('nav-btn-margin');
        }
    }

    togglePinMenu = (e) => {
        e.preventDefault();
        this.setState({
            pinnedMenu: !this.state.pinnedMenu
        }, () => {
            $("#pin-nav-menu-btn").toggleClass("unpinned");
        });
    };

    getTimeZone = () => {
        if (this.props.user) {
            if (Utils.moment_timezone.tz.names().includes(this.props.user.timeZone)) {
                return {
                    label: this.props.user.timeZone,
                    value: this.props.user.timeZone
                }
            } else {
                return {label: this.state.currentTimeZone, value: this.state.currentTimeZone}
            }
        } else {
            return {label: this.state.currentTimeZone, value: this.state.currentTimeZone}
        }
    }


    renderNavigationChildren = (children: any): any => {
        if (children) {
            const menuItems = [];
            this.props.uiRoutes.forEach(route => {
                const found = Object.keys(children).find(uiRoute => uiRoute === route);
                if (found) {
                    menuItems.push(children[found]);
                }
            })
            return menuItems
        }
        return null
    }

    hasUserAccessToParent = (routes: any): boolean => {
        let hasAccess = false;
        for (let i = 0; i < routes.length; i++) {
            const foundRoute = this.props.uiRoutes.find(uiRoute => uiRoute === routes[i]);
            if (foundRoute) {
                hasAccess = true;
                break;
            }
        }
        return hasAccess;
    }

    openJoinOrganizationsModal = () => {
        getAllTenants()
            .then((response) => {
                const tenants = response.data.map(tenant => {
                    return {
                        id: tenant.id,
                        value: tenant.id,
                        label: tenant.name
                    }
                })
                this.setState({
                    tenants: tenants,
                    organizationModal: true
                })
            })
    }

    closeJoinOrganizationsModal = () => {
        this.setState({
            organizationModal: false
        })
    }

    render() {
        const customSelectStyles = {
            menu: (provided, state) => ({
                ...provided,
                color: state.selectProps.menuColor,
                backgroundColor: '#394043 !important',
                display: 'inline-table'
            }),
            option: (styles, {data, isDisabled, isFocused, isSelected}) => {
                return {
                    ...styles,
                    color: '#f5f4f4',
                };
            },
            input: styles => ({...styles, color: '#b5b5b5'}),
            placeholder: styles => ({...styles, color: '#b5b5b5'}),
            singleValue: styles => ({...styles, color: '#b5b5b5'}),
            control: base => ({
                ...base,
                height: 34,
                minHeight: 34,
                backgroundColor: '#394043 !important',
            }),
            indicatorsContainer: base => ({
                ...base,
                height: 34,
                minHeight: 34
            }),
        };

        const localeOptions = this.props.locales.map((localeTag) => {
            return {
                value: localeTag,
                label: Utils.getLocaleNameByTag(localeTag)
            }
        });

        return (
            <nav style={{height: '100%'}} className="navbar-default navbar-static-side" role="navigation">
                <ul style={{
                    height: this.props.user?.mta ? 'calc(100% - 130px)' : 'calc(100% - 70px)',
                    maxHeight: this.props.user?.mta ? 'calc(100% - 130px)' : 'calc(100% - 70px)',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    backgroundColor: 'transparent'
                }} className="nav metismenu nav-container" id="side-menu" ref="menu">
                    <li className="nav-header nav-top-section" style={{background: 'transparent'}}>
                        <div style={{display: 'flex'}}>
                            <div className="dropdown profile-element"><span></span>
                                <a data-toggle="dropdown" className="dropdown-toggle" href="#">
                                    <span className="clear"> <span className="block m-t-xs"> <strong
                                        className="font-bold">
                                            {this.props.user ?
                                                <div>
                                                    <div>
                                                        {this.props.user.displayName}
                                                    </div>
                                                </div> : null}
                                        </strong>
                                    </span> <span className="text-muted text-xs block">Actions<b
                                        className="caret"/></span> </span> </a>
                                <ul className="dropdown-menu animated fadeInRight m-t-xs"
                                    style={{backgroundColor: '#1E1C1C', color: '#a7b1c2', border: '1px solid #a7b1c2'}}>
                                    <li><p className={'sidebar-actions-menu-item list-item-p'} id={'joinOrganization'} onClick={this.openJoinOrganizationsModal}> Join Organization</p></li>
                                    <li><a href="#" className={'sidebar-actions-menu-item'} id={'logout'} onClick={this.logout}> Logout</a></li>
                                </ul>
                            </div>
                            <div className="navbar-header">
                                <a id="pin-nav-menu-btn"
                                   title={`${this.state.pinnedMenu ? 'Unpin Menus' : 'Pin All Menus'} (CTRL + ALT + M)`}
                                   className="navbar-minimalize minimalize-styl-2 btn nav-bar-button"
                                   onClick={this.togglePinMenu} href="#"
                                   style={{background: '#3D6367', border: '1px solid #3D6367'}}><i
                                    className="fas fa-thumbtack"/> </a>
                            </div>
                            <div className="navbar-header">
                                <a id="hide-nav-btn"
                                   title="Toggle Navigation Bar"
                                   className="navbar-minimalize minimalize-styl-2 btn  nav-bar-button nav-btn-margin"
                                   onClick={Navigation.toggleNavigation} href="#"
                                   style={{background: '#3D6367', border: '1px solid #3D6367'}}><i
                                    className="fa fa-bars"/> </a>
                            </div>
                        </div>
                    </li>

                    {this.hasUserAccessToParent(this.navigationManager?.homeGroup) ?
                        <li id='home' className={'master-li'} style={{backgroundColor: 'transparent'}}>
                            <Link to={"home"}>
                                <i className="fas fa-database fa-2x"/> <span className="nav-label">Home</span><span
                                className="fa arrow"/>
                            </Link>
                            <ul id="home-children" className="nav nav-second-level collapse"
                                style={{backgroundColor: 'transparent'}}>
                                {this.renderNavigationChildren(this.navigationManager?.homeChildren)}
                            </ul>
                        </li> :
                        <li id='home' className={'master-li'} style={{backgroundColor: 'transparent'}}>
                            <Link to={"home"}>
                                <i className="fas fa-database fa-2x"/> <span className="nav-label">Home</span><span
                                className="fa arrow"/>
                            </Link>
                            <ul id="home-children" className="nav nav-second-level collapse"
                                style={{backgroundColor: 'transparent'}}>
                                <li className={this.activeRoute("welcome")}>
                                    <Link
                                        to={{
                                            pathname: `${process.env.ENV_PREFIX}/welcome`,
                                            state: {from: this.props.history.location.pathname}
                                        }}><i
                                        className="fas fa-table fa-lg"/> <span
                                        className="nav-label">Welcome</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    }

                    {this.hasUserAccessToParent(this.navigationManager?.configurationGroup) ?
                        (
                            <li id='configurations' className={'master-li'} style={{backgroundColor: 'transparent'}}>
                                <Link to={`${process.env.ENV_PREFIX}/configurations`}>
                                    <i className="fas fa-cogs fa-2x"/> <span className="nav-label">Configurations</span><span
                                    className="fa arrow"/>
                                </Link>
                                <ul id="configurations-children" className="nav nav-second-level collapse"
                                    style={{backgroundColor: 'transparent'}}>
                                    {this.renderNavigationChildren(this.navigationManager?.configurationChildren)}
                                    {this.hasUserAccessToParent(this.navigationManager?.ruleEngineGroup) ?
                                        <li id='rule-engine' className={'master-li'}
                                            style={{backgroundColor: 'transparent'}}>
                                            <Link to={`${process.env.ENV_PREFIX}/rule-engine`}
                                                  style={{paddingRight: 20}}>
                                                <i className="fas fa-book fa-sm"/><span className="nav-label">Rule Engine</span><span
                                                className="fa arrow"/>
                                            </Link>
                                            <ul id="rule-engine-children" className="nav nav-second-level collapse"
                                                style={{backgroundColor: 'transparent'}}>
                                                {this.renderNavigationChildren(this.navigationManager?.ruleEngineChildren)}
                                            </ul>
                                        </li> : null}
                                    {this.hasUserAccessToParent(this.navigationManager?.accessControlGroup) ?
                                        (
                                            <li id='access-control' className={'master-li'}
                                                style={{backgroundColor: 'transparent'}}>
                                                <Link to={`${process.env.ENV_PREFIX}/access-control`}
                                                      style={{paddingRight: 20}}>
                                                    <i className="fas fa-chalkboard-teacher"/><span
                                                    className="nav-label">Access Control</span><span
                                                    className="fa arrow"/>
                                                </Link>
                                                <ul id="access-control-children"
                                                    className="nav nav-second-level collapse"
                                                    style={{backgroundColor: 'transparent'}}>
                                                    {this.renderNavigationChildren(this.navigationManager?.accessControlChildren)}
                                                </ul>
                                            </li>
                                        )
                                        : null
                                    }
                                    {this.hasUserAccessToParent(this.navigationManager?.statusAndLogsGroup) ?
                                        (
                                            <li id='status-&-logs' className={'master-li'}
                                                style={{backgroundColor: 'transparent'}}>
                                                <Link to={`${process.env.ENV_PREFIX}/status-&-logs`}
                                                      style={{paddingRight: 20}}>
                                                    <i className="fas fa-list-alt"/><span
                                                    className="nav-label">Status & Logs</span><span
                                                    className="fa arrow"/>
                                                </Link>
                                                <ul id="status-&-logs-children"
                                                    className="nav nav-second-level collapse"
                                                    style={{backgroundColor: 'transparent'}}>
                                                    {this.renderNavigationChildren(this.navigationManager?.statusAndLogsChildren)}
                                                </ul>
                                            </li>
                                        )
                                        : null
                                    }
                                    {this.hasUserAccessToParent(this.navigationManager?.usersAndTenantsGroup) ?
                                        (
                                            <li id='status-&-logs' className={'master-li'}
                                                style={{backgroundColor: 'transparent'}}>
                                                <Link to={`${process.env.ENV_PREFIX}/users&tenants`}
                                                      style={{paddingRight: 20}}>
                                                    <i className="fas fa-table"/><span
                                                    className="nav-label">Users & Tenants</span><span
                                                    className="fa arrow"/>
                                                </Link>
                                                <ul id="status-&-logs-children"
                                                    className="nav nav-second-level collapse"
                                                    style={{backgroundColor: 'transparent'}}>
                                                    {this.renderNavigationChildren(this.navigationManager?.UsersAndTenantsChildren)}
                                                </ul>
                                            </li>
                                        )
                                        : null
                                    }
                                </ul>
                            </li>
                        )
                        : null
                    }
                </ul>
                <div style={{
                    position: "fixed",
                    width: "inherit",
                    height: 205,
                    bottom: 0
                }}>
                    <div className="nav-docs" style={{paddingLeft: 10, paddingRight: 2, height: 30}}>
                        <label>
                            <a style={{paddingLeft: '3px'}} className='sidebar-a-links' target="_blank"
                               href={Utils.getSwaggerUrl()}>
                                <i className="fas fa-book fa-2x" title='REST Documentation'/>
                                <span style={{color: "white"}}>REST Documentation</span>
                            </a>
                        </label>
                    </div>
                    <div className="nav-docs" style={{paddingLeft: 10, paddingRight: 2, height: 30}}>
                        <label>
                            <a style={{paddingLeft: '1px'}} className='sidebar-a-links' target="_blank"
                               href={Utils.getGraphQLUrl()}>
                                <p className="icon-graphql" title='GraphQL Documentation'/>
                                <span style={{color: "white", paddingLeft: '4px'}}>GraphQL Documentation</span>
                            </a>
                        </label>
                    </div>
                    <div className={'nav-drop-down'}
                         style={{height: 50, width: "100%", paddingLeft: 10, paddingRight: 10}}>
                        <AsyncPaginate
                            menuPlacement={"top"}
                            SelectComponent={Select}
                            styles={customSelectStyles}
                            cacheOptions
                            defaultOptions
                            defaultValue={this.props.tenant ? {
                                label: this.props.tenant.name,
                                value: this.props.tenant.id
                            } : null}
                            loadOptions={this.loading.bind(this)}
                            onChange={this.onTenantChange.bind(this)}
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: '#5f8c90',
                                    primary: '#34585b',
                                    primary50: '#5f8c90'
                                },
                            })}
                        />
                    </div>
                    <div className={'nav-drop-down'}
                         style={{height: 50, width: "100%", paddingLeft: 10, paddingRight: 10}}
                         id={"timezoneContainer"}>
                        <Select
                            menuPlacement={"top"}
                            styles={customSelectStyles}
                            defaultValue={this.getTimeZone()}
                            options={Utils.moment_timezone.tz.names().map(tz => {
                                return {
                                    label: `${tz} (GMT${Utils.moment_timezone.tz(tz).format('Z')})`,
                                    value: tz
                                }
                            })}
                            onChange={this.onTimeZoneChange}
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: '#5f8c90',
                                    primary: '#34585b',
                                    primary50: '#5f8c90'
                                },
                            })}
                        />
                    </div>
                    <div className={'nav-drop-down'} style={{height: 50, width: "100%", paddingLeft: 10, paddingRight: 10}} id={"localeContainer"}>
                        <Select
                            menuPlacement={"top"}
                            styles={customSelectStyles}
                            value={this.props.locale}
                            options={localeOptions}
                            onChange={this.onLocaleChange}
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: '#5f8c90',
                                    primary: '#34585b',
                                    primary50: '#5f8c90'
                                },
                            })}
                        />
                    </div>
                </div>
                <JoinTenantModal showModal={this.state.organizationModal}
                                 tenants={this.state.tenants}
                                 onCloseModal={this.closeJoinOrganizationsModal}/>
            </nav>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.auth.user,
        uiRoutes: state.auth.uiRoutes,
        tenant: state.auth.tenant,
        locale: state.auth.locale,
        locales: state.auth.locales,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setApplicationLocale: (locale: { label: string, value: string }) => {
            dispatch(setApplicationLocale(locale))
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation))



// WEBPACK FOOTER //
// ./app/components/common/Navigation/Navigation.tsx